import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  CHART_TYPE_HISTORICAL,
  isBoundaryLineShow,
  TYPE_SPEED,
} from 'helpers/environmentMonitor'
import ChartHistorical from 'components/Apps/EnvironmentMonitor/Charts/ChartHistorical'
import { fetchHistoricalData } from 'reducers/environmentMonitor/reducer'

class CurrentSpeedChart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      datasetIndex: 1,
    }
  }

  componentDidMount() {
    this.fetchChartData(this.props.activeSite)
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.activeSite !== nextProps.activeSite) {
      this.fetchChartData(nextProps.activeSite)

      return false
    }

    return true
  }

  fetchChartData = activeSite => {
    const payload = {
      site: activeSite,
      now: this.props.activeDate.utc().format('YYYY-MM-DD HH:00:00'),
      type: TYPE_SPEED,
    }

    this.props.fetchHistoricalData(payload)
  }

  render() {
    const { chartData } = this.props
    const { datasetIndex } = this.state
    const lineLevels = isBoundaryLineShow(
      chartData.get('data').toJS(),
      CHART_TYPE_HISTORICAL,
      20,
      val => val > 20,
    )

    return (
      <ChartHistorical
        unit="cm/s"
        chartData={chartData}
        datasetIndex={datasetIndex}
        lineLevels={lineLevels}
      />
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    chartData: state.getIn(['environmentMonitor', 'chartData']),
  }),
  {
    fetchHistoricalData,
  },
)(injectIntl(CurrentSpeedChart))
